import React, { useEffect, useRef, useState } from "react";
import PageNav from "../components/PageNav";
import classNames from "classnames";
import NewHomework from "./NewHomework";
import { HomeworkSvg } from "../svg/svgs";
import useOnClick from '../components/common/ClosePopUp';
import axios from "axios";
import { homeworkListModel } from "../models/dashboardModel";
import loadingSpin from '../images/loadingSpin.gif';
import { animated, useSpring } from "react-spring";
import Card from '../components/common/Card';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EmptyContent from "../components/common/EmptyContent";

const Homework = () => {
    const [displayDropdown, setDisplayDropdown] = useState(false);
    const [clickedDropdown, setClickedDropdown] = useState("All Homework");
    const [noHomework, setNoHomework] = useState(false);
    const [newHomework, setNewHomework] = useState(true);
    const [availableHomework, setavAilableHomework] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [ fetchError, setFetchError ] = useState(false);

    // const schoolDomain = window.location.host;
    const schoolDomain = localStorage.getItem('schoolDomain');
    const admissionnumber = JSON.parse(localStorage.getItem('studentInfo'))[0].admissionnumber;

    const homeworkDropdown = ["All Homework", "Due Soon", "Over Due", "Submitted", "Marked"];
    const showDropdown = classNames({
        "hidden": !displayDropdown,
        "bg-white absolute mt-10 z-10 text-gray-100 leading-4 text-xs border rounded-md border-gray-500": true
    });

    useEffect(() => {
        // getHomeWork("Due Soon");
        getHomeWork("All Homework");
        return () => {}
    }, [])

    const getHomeWork = async (homeWorkOption) => {
        let querydata = "";
        if (homeWorkOption === "Submitted") {
            querydata = "submitted"
        }
        else if (homeWorkOption === "Marked") {
            querydata = "marked"
        }
        else if (homeWorkOption === "Over Due") {
            querydata = "overdue"
        }
        else if (homeWorkOption === "Due Soon") {
            querydata = "duesoon"
        }
        else {
            querydata = ""
        }
        const queryData = {
            admissionnumber,
            SchoolUrl: schoolDomain,
            otherAction: querydata
        };
        try {
            setLoading(true)
            const { data } = await axios.post('student/homework', queryData);
            if (data.status) {
                let myHomeWork = homeworkListModel(data);
                myHomeWork[0].length === 0 && setNoHomework(true);
                // console.log(myHomeWork, "ff");
                setavAilableHomework(myHomeWork[0])
                setLoading(false)
            } else {
                setLoading(false);
                setNewHomework(false);
                setErrorMessage(data.message)
                // console.log(data.message)
            }
        } catch (error) {
            setLoading(false);
            setFetchError(true)
        }
    }

    // console.log(availableHomework, 'availableHomework')

    const showNoHomework = classNames({
        "flex justify-center w-full mt-16": true,
        "hidden": !noHomework 
    });
    const displayHomeworkContent = (item) => {
        // alert(item);
        setClickedDropdown(item);
        setDisplayDropdown(!displayDropdown);
        setNoHomework(false);
        // if (item === "New Homework") setNewHomework(true);
        getHomeWork(item);
    };
    const Heading = () => (
        <>
            <span className="text-2xl leading-7 text-white mt-1"> Homework </span>
        </>
    );
    const pageSvg = () => (
        <>
            <HomeworkSvg />
        </>
    )

    const ref = useRef();

    useOnClick(ref, () => setDisplayDropdown(false));

    const transitionStyles = useSpring({
        to: [
        { opacity: 1, transform: 'translateX(0)' },
        ],
        from: { opacity: 0, transform: 'translateX(80px)' },
        config: { duration: 700 }
    });

    return (
        <>
            <animated.div style={transitionStyles} className="px-4 sm:flex sm:-mt-2 sm:px-0">
                <div className="w-full md:w-2/3 sm:pl-2">
                    <PageNav Heading={Heading} PageSvg={pageSvg} />
                    <div className="pt-6 w-full">
                        <div className="flex ">
                            <span className="font-bold mr-4 mt-2 text-sm sm:text-base"> Filter: </span>
                            <div ref={ref} className="flex flex-col relative">
                                <span onClick={() => setDisplayDropdown(!displayDropdown)} className="flex justify-between items-center p-2 bg-white rounded-md border border-gray-600 h-10 cursor-pointer">
                                    <span className="leading-4 text-xs text-gray-100 mr-3"> {clickedDropdown} </span>
                                    <span className="pt-1">
                                        <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.76959 5.78571C3.60464 6.07143 3.19224 6.07143 3.02729 5.78571L0.0580571 0.642857C-0.1069 0.357143 0.0992962 -2.8842e-08 0.429211 0L6.36767 5.19157e-07C6.69759 5.47999e-07 6.90378 0.357143 6.73882 0.642858L3.76959 5.78571Z" fill="#000114" />
                                        </svg>
                                    </span>
                                </span>
                                <ul className={showDropdown}>
                                    {homeworkDropdown && homeworkDropdown.map(item => (
                                        <li onClick={() => displayHomeworkContent(item)} className="p-2 hover:text-blue-200 text-xs rounded border-md border-gray-200 cursor-pointer transition ease-in-out duration-100">
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        {loading ? 
                        <div className='flex justify-center w-full h-full my-24'>
                            <img src={loadingSpin} alt='loading...' />
                        </div> : 
                        <>
                            {availableHomework && availableHomework.length === 0 && 
                                <div className={showNoHomework}>
                                    <EmptyContent message='No Homework' moreMessage={`You can always check your child's homeworks here`} />
                                </div>
                            }
                            {newHomework && availableHomework.length > 0 &&
                                <div className="mt-4">
                                    <NewHomework
                                        arrayDataSets={availableHomework}
                                    />
                                </div> 
                            }
                            {
                                fetchError &&
                                <div className="mt-4 mx-auto w-64">
                                    <Card>
                                        <div className='block text-center w-full p-6'>
                                            <FontAwesomeIcon icon={faBan} className='text-red-100'/>
                                            <div className='text-xs sm:text-sm text-red-300 font-semibold'>
                                                Oops! Something Went Wrong
                                            </div>
                                            <div className='text-center text-blue-200 cursor-pointer mt-4'> 
                                                <span className='hover:text-blue-300 hover:underline' onClick={() => window.location.reload()}>
                                                    Try refresh 
                                                </span>
                                            </div>
                                        </div>
                                    </Card>
                                </div> 
                            }
                            {errorMessage &&
                                <div className="mt-4 mx-auto w-64">
                                    <Card>
                                        <div className='block text-center w-full p-6'>
                                            <FontAwesomeIcon icon={faBan} className='text-red-100'/>
                                            <div className='text-xs sm:text-sm text-red-300 font-semibold'>
                                                Oops! {errorMessage}
                                            </div>
                                            <div className='text-center text-blue-200 cursor-pointer mt-4'> 
                                                <span className='hover:text-blue-300 hover:underline' onClick={() => window.location.reload()}>
                                                Try refresh 
                                                </span>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            }
                            
                        </>
                    }
                    </div>
                </div>
            </animated.div>
        </>
    )
}

export default Homework;